<template>
  <div>
    <div>
      <div class="item">
        <span class="title">消耗时间</span>
        <el-date-picker
          v-model="date"
          :picker-options="expireTimeOption"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <div class="item">
        <span class="title">新用户充值时间</span>
        <el-date-picker
          v-model="dates"
          :picker-options="expireTimeOption"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <div class="item">
        <span class="title">主小程序</span>
        <el-autocomplete
          v-model="parameterNames.master_appid_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameterNames.master_appid_name = null),(parameter.master_appid = null)"
          @focus="current = '主小程序'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">副小程序</span>
        <!-- <el-select
          v-model="officialValue"
          multiple
          filterable
          remote
          collapse-tags
          reserve-keyword
          placeholder="请输入关键词"
          :loading="loading"
          :remote-method="remoteMethod"
          @focus="activation"
          @change="change"
        >
          <el-option
            v-for="item in fromOfficialAccount"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <span style="font-size: 32px; display: inline-block; margin: 0px 10px;">/</span> -->
        <div>
          <el-input
            v-model="multipleSub"
            style="width:150px"
            placeholder="请输入多个的名字"
            @input="handleParams"
          />
          <el-button
            type="primary"
            style="margin-left:10px"
            @click="multipleSubOfficialAccount"
          >选中多个</el-button>
        </div>
      </div>
      <div class="checkBox">
        <span class="checkBox_title">选中的小程序</span>
        <div class="checkBox_content">
          <el-tag
            v-for="item in officialObj"
            :key="item.value"
            class="content_item"
            style="margin: 5px;"
            size="small"
          >
            {{ item.label }}
            <i
              class="el-icon-close"
              style="font-size: 18px;"
              @click="deleteOfficialAccount(item)"
            /></el-tag>
        </div>

      </div>

      <div class="item">
        <span class="title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          :clearable="true"
          placeholder="请输入内容"
          @clear="(parameterNames.release_group_id_name = null),(parameter.release_group_id = null)"
          @focus="current = '投放组'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameterNames.pitcher_id_name = null),(parameter.pitcher_id = null)"
          @focus="current = '投手'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">运营组</span>
        <el-autocomplete
          v-model="parameterNames.operation_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameterNames.operation_group_id_name = null),(parameter.operation_group_id = null)"
          @focus="current = '运营组'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">运营者</span>
        <el-autocomplete
          v-model="parameterNames.operation_id_name"
          :fetch-suggestions="querySearchAsync"
          :clearable="true"
          placeholder="请输入内容"
          @clear="(parameterNames.operation_id_name = null),(parameter.operation_id = null)"
          @focus="current = '运营者'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">书籍归属</span>
        <el-autocomplete
          v-model="parameterNames.book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameterNames.book_id_name = null),(parameter.book_id = null)"
          @focus="current = '书籍归属'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">书名</span>
        <el-autocomplete
          v-model="parameterNames.alias_book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameterNames.alias_book_id_name = null),(parameter.alias_book_id = null)"
          @focus="current = '书名'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">投放位置</span>
        <el-autocomplete
          v-model="parameterNames.position_id_name"
          :fetch-suggestions="querySearchAsync"
          :clearable="true"
          placeholder="请输入内容"
          @clear="(parameterNames.position_id_name = null),(parameter.position_id = null)"
          @focus="current = '投放位置'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">广告主</span>
        <!-- <el-select
          v-model="advertiserValue"
          style="width:250px"
          multiple
          filterable
          remote
          collapse-tags
          reserve-keyword
          placeholder="请输入关键词"
          :loading="loading1"
          :remote-method="remoteMethod1"
          @focus="activation1"
          @change="change1"
        >
          <el-option
            v-for="item in fromAdvertiser"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <span style="font-size: 32px; display: inline-block; margin: 0px 10px;">/</span> -->
        <div>
          <el-input
            v-model="multipleSub1"
            style="width:150px"
            placeholder="请输入多个的名字"
            @input="handleParams1($event, 1)"
          />
          <el-button
            type="primary"
            style="margin-left:10px"
            @click="multipleSubOfficialAccount1(1)"
          >选中多个</el-button>
        </div>
      </div>
      <div class="checkBox">
        <span class="checkBox_title">选中的广告主</span>
        <div
          v-for="item in advertiserObj"
          :key="item.value"
          class="checkBox_content"
        >
          <el-tag
            class="content_item"
            style="margin: 5px;"
            size="small"
          >{{ item.label }}
            <i
              class="el-icon-close"
              style="font-size: 18px;"
              @click="deleteOfficialAccount1(item,1)"
            /></el-tag>
        </div>
      </div>

      <div class="item">
        <span class="title">巨量广告</span>
        <div>
          <el-input
            v-model="multipleSub2"
            style="width:150px"
            placeholder="请输入多个的名字"
            @input="handleParams1($event, 2)"
          />
          <el-button
            type="primary"
            style="margin-left:10px"
            @click="multipleSubOfficialAccount1(2)"
          >选中多个</el-button>
        </div>
      </div>
      <div class="checkBox">
        <span class="checkBox_title">选中的巨量广告</span>
        <div
          v-for="item in advertiserObj1"
          :key="item.value"
          class="checkBox_content"
        >
          <el-tag
            class="content_item"
            style="margin: 5px;"
            size="small"
          >{{ item.label }}<i
            class="el-icon-close"
            style="font-size: 18px;"
            @click="deleteOfficialAccount1(item, 2)"
          /></el-tag>
          <el-date-picker
            v-model="item.date"
            :picker-options="expireTimeOption"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </div>
      </div>

      <div class="item">
        <span class="title">平台id</span>
        <el-select
          v-model="parameter.platform_id"
          style="margin-right: 20px"
          placeholder="请选择平台"
          filterable
          :clearable="true"
          @clear="parameter.platform_id = null"
        >
          <el-option
            v-for="(item, index) in platformSelectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
    </div>

    <div style="text-align: end; margin-top:20px">
      <el-button
        class=""
        type="primary"
        @click="determine"
      >确定</el-button>
    </div>
  </div>
</template>

<script>
import { getTheListOfOfficialAccount, getReleaseGroupList, getListOfPitchersInTheLaunchGroup, getOperationGroupList, getOperatorList, getTitleList, getBookOwnershipList, dropLocationList, getAdvertiser, getPlatform } from '@/api/copyReleaseGroup.js'
export default {
  props: {
    drawerItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      expireTimeOption: {
        disabledDate(date) {}
      },
      parameter: {
        master_appid: null, // 主小程序
        release_group_id: null, // 投放组
        pitcher_id: null, // 投手
        operation_group_id: null, // 运营组
        operation_id: null, // 运营者
        alias_book_id: null, // 书名
        book_id: null, // 书籍归属
        position_id: null, // 投放位置
        platform_id: null // 平台
      },
      parameterNames: {
        master_appid_name: null, // 主小程序
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        operation_group_id_name: null, // 运营组
        operation_id_name: null, // 运营者
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        position_id_name: null, // 投放位置
        app_id_name: null // 平台
      },
      current: null,
      loading: false,
      loading1: false,
      date: [],
      dates: [],
      officialValue: [], // 副小程序值
      fromOfficialAccount: [], // 从公众号
      officialObj: [], // 辅助渲染的公众号
      platformSelectList: [],
      advertiserValue: [], // 广告主值
      advertiserValue1: [], // 巨量广告主值
      fromAdvertiser: [], // 广告主
      fromAdvertiser1: [], // 巨量广告
      advertiserObj: [
      ], // 辅助广告主渲染
      advertiserObj1: [], // 辅助巨量广告渲染
      multipleSub: null, // 输入的多个从公众号的名字
      multipleSub1: null, // 输入的多个广告主的名字
      multipleSub2: null // 输入的多个巨量广告的名字
    }
  },
  created() {
    window.aaa = this
    this.myGetchannelplatform() // 获取平台
    this.init()
  },
  mounted() {},
  methods: {
    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '主小程序':
          this.parameter.master_appid = item
          break
        case '投放组':
          this.parameter.release_group_id = item
          break
        case '投手':
          this.parameter.pitcher_id = item
          break
        case '运营组':
          this.parameter.operation_group_id = item
          break
        case '运营者':
          this.parameter.operation_id = item
          break
        case '书名':
          this.parameter.alias_book_id = item
          break
        case '书籍归属':
          this.parameter.book_id = item
          break
        case '投放位置':
          this.parameter.position_id = item
          break
      }
    },
    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        主小程序: 'account_name',
        投放组: 'release_group_name',
        投手: 'user_name',
        运营组: 'operation_group_name',
        运营者: 'user_name',
        书籍归属: 'book_name',
        书名: 'novel_name',
        投放位置: 'position_name'
      }

      switch (this.current) {
        case '主小程序':
          currentFunc = getTheListOfOfficialAccount
          break
        case '从公众号':
          currentFunc = getTheListOfOfficialAccount
          break
        case '投放组':
          currentFunc = getReleaseGroupList
          break
        case '投手':
          currentFunc = getListOfPitchersInTheLaunchGroup
          break
        case '运营组':
          currentFunc = getOperationGroupList
          break
        case '运营者':
          currentFunc = getOperatorList
          break
        case '书名':
          currentFunc = getTitleList
          break
        case '书籍归属':
          currentFunc = getBookOwnershipList
          break
        case '投放位置':
          currentFunc = dropLocationList
          break
      }
      if (!currentFunc) {
        return
      }
      console.log('this.current:', this.current)
      if ((this.current === '投手' && !this.parameter.release_group_id) || (this.current === '运营者' && !this.parameter.operation_group_id) || (this.current === '书名' && !this.parameter.book_id) || (this.current === '从公众号' && !this.parameter.master_appid)) {
        const obj1 = {
          投手: '请先选投放组，才能选投手',
          运营者: '请先选运营组，才能选运营者',
          书名: '请先选择书籍归属，才能选书名',
          从公众号: '请先选择主小程序，才能选从公众号'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      const data = await currentFunc({
        name: queryString || null,
        group_id: this.current === '投手' ? this.parameter.release_group_id.address : this.current === '运营者' ? this.parameter.operation_group_id.address : null,
        book_belong_id: this.parameter.book_id ? this.parameter.book_id.address : null
      })
      // console.log('data:', data)
      if (this.current === '投手') {
        cb(
          data.data.group_user.map(item => {
            return {
              value: item.nickname,
              address: item.bind_id
            }
          })
        )
        return
      }
      cb(
        data.data.list.map(item => {
          return {
            value: this.current === '书名' ? item['novel_name'] + (item['platform'] ? '(' + item['platform'] + ')' : '') : item[obj[this.current]],
            address: this.current === '主小程序' ? item.app_id : item.id
          }
        })
      )
    },

    // 搜索公众号
    async remoteMethod(query) {
      this.activation(query)
    },

    // 搜索公众号
    async activation(query = null) {
      this.current = '从公众号'
      this.loading = true
      const data = await getTheListOfOfficialAccount({ name: typeof query === 'object' || query === '' ? null : query })
      this.loading = false
      this.fromOfficialAccount = data.data.list.map(item => {
        return {
          value: item.app_id,
          label: item.account_name
        }
      })
    },

    // 请求平台
    async myGetchannelplatform() {
      const data = await getPlatform({ type: 1 })
      this.platformSelectList = data.data.list
    },
    // 请求初始书名
    async getTitleList() {
      const data = await getTitleList({
        book_alias_id: this.drawerItem.alias_book_id,
        book_belong_id: this.drawerItem.book_id
      })
      // 书名
      this.parameterNames.alias_book_id_name = data.data.list[0].novel_name + (data.data.list[0].platform ? '(' + data.data.list[0].platform + ')' : '')
      this.parameter.alias_book_id = this.parameterNames.alias_book_id_name && {
        value: this.parameterNames.alias_book_id_name,
        address: this.drawerItem.alias_book_id
      }
    },
    // 选择公众号
    change(items) {
      if (!items.length) {
        this.officialObj = []
        return
      }
      for (let i = 0; i < items.length; i++) {
        const im = items[i]
        const index = this.officialObj.findIndex(itemm => itemm.value === im)
        if (index < 0) {
          this.officialObj.push({
            value: im,
            label: this.fromOfficialAccount[this.fromOfficialAccount.findIndex(itemm => itemm.value === im)].label
          })
        } else {
          this.officialObj = this.officialObj.filter(imm => {
            return !(items.indexOf(imm.value) < 0)
          })
        }
      }
    },

    // 删除公众号
    deleteOfficialAccount(item) {
      this.officialObj.splice(
        this.officialObj.findIndex(im => im.value === item.value),
        1
      )
      this.officialValue.splice(this.officialValue.indexOf(item.value), 1)
    },

    // 搜索广告主
    async remoteMethod1(query) {
      this.activation1(query)
    },

    // 搜索广告主
    async activation1(query = null) {
      this.current = '广告主'
      this.loading1 = true
      const data = await getAdvertiser({ name: typeof query === 'object' || query === '' ? null : query })
      this.loading1 = false
      this.fromAdvertiser = data.data.list.map(item => {
        return {
          value: item.account_id,
          label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
        }
      })
    },

    // 选择广告主
    change1(item, arr) {
      console.log(item, 'change1接收到的item', arr, 'arr')
      const labelMap = arr.reduce((acc, item) => {
        acc[item.value] = item.label
        return acc
      }, {})

      for (let i = 0; i < this.advertiserValue.length; i++) {
        const im = this.advertiserValue[i]

        // 查找是否已经存在
        const index = this.advertiserObj.findIndex(item => item.value === im)

        if (index < 0) {
          const label = labelMap[im] || '' // 从 labelMap 中获取 label，如果没有则为空
          this.advertiserObj.push({ value: im, label })
        }
      }
      this.advertiserObj = this.advertiserObj.filter(imm => {
        return !(item.indexOf(imm.value) < 0)
      })
      const uniqueValues = this.advertiserObj.reduce((accumulator, currentValue) => {
        const existingIndex = accumulator.findIndex(item => item.value === currentValue.value)

        if (existingIndex !== -1) {
          accumulator.splice(existingIndex, 1, currentValue)
        } else {
          accumulator.push(currentValue)
        }

        return accumulator
      }, [])
      console.log(uniqueValues)
      this.advertiserObj = uniqueValues
    },
    // 选择巨量
    change2(item, arr) {
      const labelMap = arr.reduce((acc, item) => {
        acc[String(item.value)] = item.label
        return acc
      }, {})
      for (let i = 0; i < this.advertiserValue1.length; i++) {
        const im = String(this.advertiserValue1[i]) // 统一转换为字符串
        const index = this.advertiserObj1.findIndex(itemm => String(itemm.value) === im)
        const label = labelMap[im] || '' // 从 labelMap 中获取 label，如果没有则为空
        index < 0 && this.advertiserObj1.push({ value: im, label: label })
      }
      this.advertiserObj1 = this.advertiserObj1.filter(imm => {
        return !(item.indexOf(String(imm.value)) < 0)
      })
    },
    // 删除广告主
    deleteOfficialAccount1(item, index) {
      if (index === 1) {
        this.advertiserObj.splice(
          this.advertiserObj.findIndex(im => im.value === item.value),
          1
        )
        this.advertiserValue.splice(this.advertiserValue.indexOf(item.value), 1)
      } else {
        this.advertiserObj1.splice(
          this.advertiserObj1.findIndex(im => String(im.value) === String(item.value)),
          1
        )
        this.advertiserValue1.splice(this.advertiserValue1.indexOf(String(item.value)), 1)
      }
    },

    // 确定
    determine() {
      if (this.judgmentParameters()) {
        if (this.advertiserObj1.length !== 0) {
          this.advertiserObj1.forEach((v, i) => {
            if (!v.date) {
              console.log(211, v, i)
              return this.$message({
                message: `请选择巨量广告第${i + 1}条的时间`,
                type: 'warning'
              })
            }
          })
        }
        console.log('进来了')
        const parameter = this.assemblyParameters()
        this.$emit('determine', parameter)
      }
    },

    // 判断参数
    judgmentParameters() {
      let text = null

      if (!this.parameter.master_appid || this.parameter.master_appid.value !== this.parameterNames.master_appid_name) {
        text = '请选择主小程序'
      } else if (!this.parameter.release_group_id || this.parameter.release_group_id.value !== this.parameterNames.release_group_id_name) {
        text = '请选择投放组'
      } else if (!this.parameter.pitcher_id || this.parameter.pitcher_id.value !== this.parameterNames.pitcher_id_name) {
        text = '请选择投手'
      } else if (!this.parameter.operation_group_id || this.parameter.operation_group_id.value !== this.parameterNames.operation_group_id_name) {
        text = '请选择运营组'
      } else if (!this.parameter.operation_id || this.parameter.operation_id.value !== this.parameterNames.operation_id_name) {
        text = '请选择运营者'
      } else if (!this.parameter.book_id || this.parameter.book_id.value !== this.parameterNames.book_id_name) {
        text = '请选择书籍归属'
      } else if (!this.parameter.alias_book_id || this.parameter.alias_book_id.value !== this.parameterNames.alias_book_id_name) {
        text = '请选择书名'
      } else if (!this.parameter.position_id || this.parameter.position_id.value !== this.parameterNames.position_id_name) {
        text = '请选择投放位置'
      } else if (!this.advertiserValue.length && !this.advertiserValue1.length) {
        text = '请选择广告主或者巨量广告'
      } else if (!this.parameter.platform_id) {
        text = '请选择平台'
      } else if (!this.date || !this.date.length) {
        text = '请选择日期'
      } else if (!this.dates || !this.dates.length) {
        text = '请选择新用户充值时间'
      } else if (this.advertiserObj.length === 0 && this.advertiserObj1.length === 0) {
        text = '广告主选项或巨量广告选项要有一个不为空'
      }
      console.log(4, this.advertiserObj1.length)
      text &&
        this.$message({
          message: text,
          type: 'warning'
        })

      console.log('text:', text)
      return !text
    },

    // 组装参数
    assemblyParameters() {
      const obj = {
        begin_time: this.date[0],
        end_time: this.date[1],
        recharge_begin: this.dates[0],
        recharge_end: this.dates[1],
        master_appid: this.parameter.master_appid.address,
        app_ids: this.officialValue,
        release_group_id: this.parameter.release_group_id.address,
        pitcher_id: this.parameter.pitcher_id.address,
        operation_group_id: this.parameter.operation_group_id.address,
        alias_book_id: this.parameter.alias_book_id.address,
        book_id: this.parameter.book_id.address,
        position_id: this.parameter.position_id.address,
        advertiser_ids: this.advertiserValue,
        ocean_advertiser_ids: this.advertiserValue1,
        operation_id: this.parameter.operation_id.address,
        platform_id: this.parameter.platform_id
      }

      return obj
    },

    // 初始化
    init() {
      if (this.drawerItem && this.drawerItem.id) {
        this.getTitleList()
      } else {
        // 书名
        this.parameterNames.alias_book_id_name = this.drawerItem.novel_name
        this.parameter.alias_book_id = this.parameterNames.alias_book_id_name && {
          value: this.parameterNames.alias_book_id_name,
          address: this.drawerItem.alias_book_id
        }
      }
      if (this.drawerItem.begin_time && this.drawerItem.end_time) {
        // 时间
        this.date[0] = this.drawerItem.begin_time
        this.date[1] = this.drawerItem.end_time
      }
      if (this.drawerItem.recharge_begin && this.drawerItem.recharge_end) {
        // 新用户充值时间
        this.dates[0] = this.drawerItem.recharge_begin
        this.dates[1] = this.drawerItem.recharge_end
      }

      // 主小程序
      this.parameterNames.master_appid_name = this.drawerItem.wechat_names && this.drawerItem.wechat_names.length ? this.drawerItem.wechat_names[0] : null
      this.parameter.master_appid = this.parameterNames.master_appid_name && {
        value: this.drawerItem.wechat_names[0],
        address: this.drawerItem.master_appid
      }

      // 副小程序
      this.officialValue = this.drawerItem.app_ids && this.drawerItem.app_ids.length ? [...Object.values(this.drawerItem.app_ids).slice(1)] : []

      this.fromOfficialAccount = this.officialValue.map((item, index) => {
        return {
          value: item,
          label: this.drawerItem.wechat_names[index + 1]
        }
      })

      this.officialObj = this.officialValue.map((item, index) => {
        return {
          value: item,
          label: this.drawerItem.wechat_names[index + 1]
        }
      })

      // 投放组
      this.parameterNames.release_group_id_name = this.drawerItem.release_group_name
      this.parameter.release_group_id = this.parameterNames.release_group_id_name && {
        value: this.drawerItem.release_group_name,
        address: this.drawerItem.release_group_id
      }

      // 投手
      this.parameterNames.pitcher_id_name = this.drawerItem.pitcher_name
      this.parameter.pitcher_id = this.parameterNames.pitcher_id_name && {
        value: this.drawerItem.pitcher_name,
        address: this.drawerItem.pitcher_id
      }

      // 运营组
      this.parameterNames.operation_group_id_name = this.drawerItem.operation_group_name
      this.parameter.operation_group_id = this.parameterNames.operation_group_id_name && {
        value: this.drawerItem.operation_group_name,
        address: this.drawerItem.operation_group_id
      }

      // 运营者
      this.parameterNames.operation_id_name = this.drawerItem.operation_name
      this.parameter.operation_id = this.parameterNames.operation_id_name && {
        value: this.drawerItem.operation_name,
        address: this.drawerItem.operation_id
      }

      // 书籍归属
      this.parameterNames.book_id_name = this.drawerItem.belong_name
      this.parameter.book_id = this.parameterNames.book_id_name && {
        value: this.drawerItem.belong_name,
        address: this.drawerItem.book_id
      }
      // 投放位置
      this.parameterNames.position_id_name = this.drawerItem.position_name
      this.parameter.position_id = this.parameterNames.position_id_name && {
        value: this.drawerItem.position_name,
        address: this.drawerItem.position_id
      }

      // 广告主
      this.advertiserValue = this.drawerItem.advertiser_ids && this.drawerItem.advertiser_ids.length ? [...this.drawerItem.advertiser_ids] : []

      this.fromAdvertiser = this.advertiserValue.length
        ? this.drawerItem.advertiser.map((item, index) => {
          return {
            value: item.account_id,
            label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
          }
        })
        : []

      this.advertiserObj = this.advertiserValue.length
        ? this.drawerItem.advertiser.map((item, index) => {
          return {
            value: item.account_id,
            label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`,
            date: item.date
          }
        })
        : []
      const arr = []
      if (arr.length !== 0) {
        this.advertiserObj = arr
      }

      // 巨量广告
      this.advertiserValue1 = this.drawerItem.ocean_advertiser_ids && this.drawerItem.ocean_advertiser_ids.length ? this.drawerItem.ocean_advertiser_ids.map(id => String(id)) : []
      this.fromAdvertiser1 = this.advertiserValue1.length
        ? this.drawerItem.ocean_advertiser.map((item, index) => {
          return {
            value: String(item.account_id), // 强制转换为字符串
            label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`,
            date: item.date
          }
        })
        : []
      this.advertiserObj1 = this.advertiserValue1.length
        ? this.drawerItem.ocean_advertiser.map((item, index) => {
          return {
            value: String(item.account_id), // 强制转换为字符串
            label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
          }
        })
        : []
      const arr1 = []
      // 广告主中得时间
      if (arr1.length !== 0) {
        this.advertiserObj1 = arr1
      }

      // 平台
      this.parameter.platform_id = this.drawerItem.platform_id
    },

    // 选中多个副小程序
    async multipleSubOfficialAccount() {
      if (!this.multipleSub) {
        this.$message({
          message: '必须输入 id 或 名字',
          type: 'warning'
        })
        return
      }

      // 获取公众号
      const data = await getTheListOfOfficialAccount({ name: this.multipleSub })

      // 判断是否为空
      if (!data.data.list.length) {
        this.$message({
          message: '筛选为0个，没法选中',
          type: 'warning'
        })
      }

      // 将获取到的公众号变更下字段名
      let news = data.data.list.map(item => {
        return {
          value: item.app_id,
          label: item.account_name
        }
      })

      this.fromOfficialAccount = news

      for (let i = 0; i < news.length; i++) {
        this.officialValue.indexOf(news[i].value) < 0 && this.officialValue.push(news[i].value)
      }

      news = news.map(im => im.value)

      for (let i = 0; i < this.officialValue.length; i++) {
        news.indexOf(this.officialValue[i]) < 0 && news.push(this.officialValue[i])
      }

      this.change(news)

      data.data.list.length && this.judgeThatOneIsNotSelected(this.multipleSub, data.data.list, 'app_id')

      this.multipleSub = null
    },

    handleParams(value) {
      const str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、 ]/gim
      this.multipleSub = value.replace(str, ',')

      const str1 = /(,){1,}/gim
      this.multipleSub = this.multipleSub.replace(str1, ',')
    },

    handleParams1(value, index) {
      if (index === 1) {
        const str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、 ]/gim
        this.multipleSub1 = value.replace(str, ',')

        const str1 = /(,){1,}/gim
        this.multipleSub1 = this.multipleSub1.replace(str1, ',')
      } else {
        const str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、 ]/gim
        this.multipleSub2 = value.replace(str, ',')

        const str1 = /(,){1,}/gim
        this.multipleSub2 = this.multipleSub2.replace(str1, ',')
      }
    },
    // 选中多个广告主或者巨量广告
    async multipleSubOfficialAccount1(type) {
      if (type === 1) {
        if (!this.multipleSub1) {
          this.$message({
            message: '必须输入广告主 id 或 名字',
            type: 'warning'
          })
          return
        }
      } else {
        if (!this.multipleSub2) {
          this.$message({
            message: '必须输入巨量广告 id 或 名字',
            type: 'warning'
          })
          return
        }
      }
      const data = await getAdvertiser({ name: type === 1 ? this.multipleSub1 : this.multipleSub2, type: type })
      if (!data.data.list.length) {
        this.$message({
          message: '筛选为0个，没法选中',
          type: 'warning'
        })
      }
      let news = data.data.list.map(item => {
        return {
          value: type === 1 ? item.account_id : String(item.account_id), // 巨量广告强制转换为字符串
          label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
        }
      })
      const arr = JSON.parse(JSON.stringify(news))

      if (type === 1) {
        // 广告主模块
        this.fromAdvertiser = news
        for (let i = 0; i < news.length; i++) {
          this.advertiserValue.indexOf(news[i].value) < 0 && this.advertiserValue.push(news[i].value)
        }
        news = news.map(im => im.value)
        for (let i = 0; i < this.advertiserValue.length; i++) {
          news.indexOf(this.advertiserValue[i]) < 0 && news.push(this.advertiserValue[i])
        }

        this.change1(news, arr)
        data.data.list.length && this.judgeThatOneIsNotSelected(this.multipleSub1, data.data.list, 'account_id')
        this.multipleSub1 = null
        console.log(555)
      } else {
        // 巨量广告模块
        this.fromAdvertiser1 = news
        for (let i = 0; i < news.length; i++) {
          this.advertiserValue1.indexOf(news[i].value) < 0 && this.advertiserValue1.push(news[i].value)
        }
        news = news.map(im => im.value)
        for (let i = 0; i < this.advertiserValue1.length; i++) {
          news.indexOf(String(this.advertiserValue1[i])) < 0 && news.push(String(this.advertiserValue1[i]))
        }
        this.change2(news, arr)
        data.data.list.length && this.judgeThatOneIsNotSelected(this.multipleSub2, data.data.list, 'account_id')
        this.multipleSub2 = null
      }
    },

    // 创建渲染回填时想要的结构数据
    createTheDesiredStructure(isL) {
      console.log('isL:', isL)
      const obj = !isL
        ? {
          begin_time: this.date && this.date[0], // 开始时间
          end_time: this.date && this.date[1], // 结束时间
          recharge_begin: this.dates && this.dates[0], // 新用户充值开始时间
          recharge_end: this.dates && this.dates[1], // 新用户充值结束时间
          wechat_names: this.parameterNames.master_appid_name ? [this.parameterNames.master_appid_name, ...this.officialObj.map(item => item.label)] : [...this.officialObj.map(item => item.label)], // 选择的公众号的值

          master_appid: this.parameter.master_appid && this.parameter.master_appid.address, // 主小程序的id

          app_ids: this.parameter.master_appid ? [this.parameter.master_appid, ...this.officialValue] : [...this.officialValue], // 选中的公众号的id

          // 投放组
          release_group_name: this.parameterNames.release_group_id_name,
          release_group_id: this.parameter.release_group_id && this.parameter.release_group_id.address,

          // 投手
          pitcher_id: this.parameter.pitcher_id && this.parameter.pitcher_id.address,
          pitcher_name: this.parameterNames.pitcher_id_name,

          // 运营组
          operation_group_name: this.parameterNames.operation_group_id_name,
          operation_group_id: this.parameter.operation_group_id && this.parameter.operation_group_id.address,

          // 运营者
          operation_name: this.parameterNames.operation_id_name,
          operation_id: this.parameter.operation_id && this.parameter.operation_id.address,

          // 书籍归属
          belong_name: this.parameterNames.book_id_name,
          book_id: this.parameter.book_id && this.parameter.book_id.address,

          // 书名
          novel_name: this.parameterNames.alias_book_id_name,
          alias_book_id: this.parameter.alias_book_id && this.parameter.alias_book_id.address,

          // 投放位置
          position_name: this.parameterNames.position_id_name,
          position_id: this.parameter.position_id && this.parameter.position_id.address,

          // 平台
          platform_id: this.parameter.platform_id,

          // 广告主
          advertiser_ids: this.advertiserValue && this.advertiserValue.length ? this.advertiserValue : [],
          advertiser:
              this.advertiserObj && this.advertiserObj.length
                ? this.advertiserObj.map(item => {
                  const s = item.label.split('--')
                  return {
                    account_id: item.value,
                    account_name: s[0],
                    agent_name: s[s.length - 1],
                    date: item.date
                  }
                })
                : [],
          // 巨量广告
          ocean_advertiser_ids: this.advertiserValue1 && this.advertiserValue1.length ? this.advertiserValue1 : [],
          ocean_advertiser:
              this.advertiserObj1 && this.advertiserObj1.length
                ? this.advertiserObj1.map(item => {
                  const s = item.label.split('--')
                  return {
                    account_id: item.value,
                    account_name: s[0],
                    agent_name: s[s.length - 1],
                    date: item.date
                  }
                })
                : []
        }
        : {}

      console.log('obj:', obj)
      return obj
    },

    // 判断那个没选中
    judgeThatOneIsNotSelected(texts, arr, idName) {
      const testsr = texts.split(',')
      const unchecked = []
      testsr.forEach(text => {
        let bool = true
        for (let i = 0; i < arr.length; i++) {
          if (String(arr[i][idName]) === String(text) || String(arr[i].account_name) === String(text)) {
            bool = false
            break
          }
        }
        bool && unchecked.push(text)
      })

      unchecked.length &&
        this.$message({
          message: unchecked.join() + '  没被选中',
          type: 'warning'
        })
    }
  }
}
</script>

<style scoped>
.item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.item .title {
  display: inline-block;
  width: 110px;
}

.checkBox {
  margin-bottom: 26px;
}

.checkBox_title {
}

.checkBox_content {
}

.content_item {
}
</style>
